{
  "courses": {
    "title": "Kurse & Schulungen",
    "createButton": "Neuer Kurs",
    "createStudentButton": "Neuer Student",
    "createTitle": "Kurs erstellen",
    "editTitle": "Kurs bearbeiten",
    "backToList": "Zurück zur Liste",
    "searchPlaceholder": "Nach Titel oder Ort suchen...",
    "allStatuses": "Alle Status",
    "allLevels": "Alle Niveaus",
    "noData": "Keine Kurse gefunden",
    "noTeacher": "Kein Lehrer",
    "nextSession": "Nächste Sitzung:",
    "columns": {
      "title": "Titel",
      "level": "Niveau",
      "duration": "Dauer",
      "price": "Preis",
      "status": "Status",
      "nextSession": "Nächste Sitzung",
      "fill": "Auslastung",
      "teachers": "Lehrer"
    },
    "level": {
      "Basic": "Grundlagen",
      "Intermediate": "Mittelstufe",
      "Expert": "Experte",
      "ExpertFinishes": "Experte — Finishing"
    },
    "status": {
      "Draft": "Entwurf",
      "Published": "Veröffentlicht",
      "Archived": "Archiviert"
    },
    "sessionStatus": {
      "Scheduled": "Geplant",
      "Open": "Offen",
      "Full": "Voll",
      "Cancelled": "Abgesagt",
      "Completed": "Abgeschlossen"
    },
    "form": {
      "title": "Titel",
      "titleRequired": "Titel ist erforderlich",
      "description": "Beschreibung",
      "level": "Niveau",
      "status": "Status",
      "durationMinutes": "Dauer (Minuten)",
      "location": "Ort",
      "language": "Sprache",
      "maxStudents": "Max. Teilnehmer",
      "price": "Preis (EUR)"
    },
    "archive": {
      "title": "Kurs archivieren",
      "confirm": "\"{{title}}\" archivieren?",
      "action": "Archivieren"
    },
    "sessions": {
      "title": "Sitzungen",
      "empty": "Noch keine Sitzungen",
      "noComing": "Keine bevorstehenden Sitzungen",
      "showPast": "Vergangene anzeigen ({{count}})"
    },
    "session": {
      "createButton": "Sitzung hinzufügen",
      "createTitle": "Sitzung hinzufügen",
      "editTitle": "Sitzung bearbeiten",
      "date": "Datum",
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "location": "Ort",
      "country": "Land",
      "availableSeats": "Verfügbare Plätze",
      "status": "Status",
      "seats": "Plätze",
      "until": "bis",
      "enrollments": "Anmeldungen",
      "students": "Studenten",
      "noStudents": "Keine Teilnehmer",
      "addStudent": "Teilnehmer hinzufügen",
      "edit": "Sitzung bearbeiten",
      "deleteTitle": "Sitzung löschen",
      "deleteConfirm": "Sind Sie sicher, dass Sie diese Sitzung löschen möchten? Alle Anmeldungen werden entfernt.",
      "complete": "Abschließen",
      "reopen": "Wiederöffnen"
    },
    "enroll": {
      "title": "Teilnehmer anmelden",
      "button": "Anmelden",
      "action": "Anmelden",
      "search": "Teilnehmer suchen",
      "searchPlaceholder": "Tippen zum Suchen...",
      "student": "Student",
      "studentPlaceholder": "Student auswählen...",
      "noResults": "Keine Studenten gefunden",
      "noEnrollments": "Noch keine Anmeldungen",
      "remove": "Abmelden",
      "removeTitle": "Anmeldung entfernen",
      "removeConfirm": "{{name}} aus dieser Sitzung entfernen?",
      "columns": {
        "name": "Name",
        "email": "E-Mail",
        "enrolledAt": "Angemeldet am"
      }
    },
    "teachers": {
      "title": "Lehrer",
      "add": "Lehrer hinzufügen",
      "empty": "Kein Lehrer zugewiesen",
      "assign": "Zuweisen",
      "removeTitle": "Lehrer entfernen",
      "removeConfirm": "{{name}} aus diesem Kurs entfernen?",
      "select": "Lehrer auswählen..."
    },
    "enrollmentStatus": {
      "Registered": "Angemeldet",
      "Attended": "Anwesend",
      "Completed": "Abgeschlossen",
      "Cancelled": "Abgesagt"
    },
    "attendance": {
      "edit": "Anwesenheit bearbeiten",
      "present": "Anwesend",
      "absent": "Abwesend",
      "comment": "Kommentar",
      "commentTitle": "Kommentar hinzufügen",
      "commentPlaceholder": "Kommentar (optional)..."
    },
    "create": {
      "successTitle": "Kurs erstellt",
      "successMessage": "Der Kurs wurde erfolgreich erstellt.",
      "errorTitle": "Fehler",
      "errorMessage": "Der Kurs konnte nicht erstellt werden."
    }
  }
}